import { getAdminUserBillingTasksHeaders } from './getAdminUserBillingTasksHeaders'

export const getAdminBillingsTasksHeaders = getAdminUserBillingTasksHeaders
